import { render, staticRenderFns } from "./ConfigFormatsExogena.vue?vue&type=template&id=394e960e&scoped=true"
import script from "./ConfigFormatsExogena.vue?vue&type=script&lang=js"
export * from "./ConfigFormatsExogena.vue?vue&type=script&lang=js"
import style0 from "./ConfigFormatsExogena.vue?vue&type=style&index=0&id=394e960e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e960e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394e960e')) {
      api.createRecord('394e960e', component.options)
    } else {
      api.reload('394e960e', component.options)
    }
    module.hot.accept("./ConfigFormatsExogena.vue?vue&type=template&id=394e960e&scoped=true", function () {
      api.rerender('394e960e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/taxreports/components/ConfigFormatsExogena.vue"
export default component.exports